import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
// import axios from 'axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

Vue.config.productionTip = true
Vue.use(vueNumeralFilterInstaller)
Vue.use(require('vue-moment'))
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

require('./assets/semantic/dist/semantic.min.css')
require('./assets/semantic/dist/semantic.min.js')

// Vue.use(axios)

// let ip = '192.168.1.45:9000' ;

// Vue.prototype.$apiflask = 'http://127.0.0.1:8080/'
// Vue.prototype.$apiAuthen = 'http://localhost:9000/authen/'
// Vue.prototype.$api = 'http://localhost:9000/nygcontrolroom/'

Vue.prototype.$apiAuthen = 'https://webalert.nanyangtextile.com/authen/'
// console.log(Vue.prototype.$apiAuthen)

Vue.prototype.$api = 'https://webalert.nanyangtextile.com/nygcontrolroom/'
// Vue.prototype.$api = 'http://localhost/nygcontrolroom/api/'

Vue.prototype.$keycode = 'MuWTvUwHYbS2#*78!_?@HZ6fgQ9GLneEdncJ=&9U6YgHNUd*sp'

// Vue.prototype.$apiflask = 'http://172.16.9.89:9080/'
Vue.prototype.$apiflask = 'http://qbi.nanyangtextile.com:9080/'

Vue.prototype.$apiFix = 'https://webalert.nanyangtextile.com/nygcontrolroom/'
// Vue.prototype.$apiFix = 'http://localhost/nygcontrolroom/api/'

// Vue.prototype.$apiRoomPage1 = 'http://127.0.0.1:9000/nygcontrolroom/'
// Vue.prototype.$apiRoomPage1 = '/controlroom/api/' ;
Vue.prototype.$apiRoomPage1 = 'https://webalert.nanyangtextile.com/nygcontrolroom/'
Vue.prototype.$appName = 'Control Room Garment'
Vue.prototype.$syscode = 'CTRNYG'

Vue.prototype.$makeItFalsy = function (it) {
  this.it = !this.it
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
